import React, { createContext, useContext, useState } from 'react';
import { AMAZON_MAINTENANCE_TITLE, AMAZON_MAINTENANCE_MESSAGE } from '../config/amazonMaintenance';

const NotificationContext = createContext();

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
};

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);

  const showNotification = (notification) => {
    const id = Date.now() + Math.random();
    const newNotification = {
      id,
      ...notification,
      timestamp: new Date()
    };
    
    setNotifications(prev => [...prev, newNotification]);
    
    return id;
  };

  const removeNotification = (id) => {
    setNotifications(prev => prev.filter(notification => notification.id !== id));
  };

  const showAmazonPushResult = (success, message) => {
    return showNotification({
      type: 'amazon_push',
      title: success ? 'Successfully Pushed to Amazon' : 'Error Pushing to Amazon',
      message: message,
      success: success
    });
  };

  const showAmazonMaintenanceMessage = () => {
    return showNotification({
      type: 'amazon_maintenance',
      title: AMAZON_MAINTENANCE_TITLE,
      message: AMAZON_MAINTENANCE_MESSAGE,
      success: false
    });
  };

  return (
    <NotificationContext.Provider value={{
      notifications,
      showNotification,
      removeNotification,
      showAmazonPushResult,
      showAmazonMaintenanceMessage
    }}>
      {children}
    </NotificationContext.Provider>
  );
};
